// PUT

import axios, { AxiosResponse } from 'axios';
import { UpdateDefaultSiteProfileInput } from '../types/update-default-site-profile-input.type';

// /ewosapi/v2/planandprognosis/default-profile/site/{globalSiteId}
export const putDefaultSiteProfile = async (
  globalSiteId: string,
  request: UpdateDefaultSiteProfileInput
): Promise<AxiosResponse> => {
  return await axios.put<AxiosResponse>(`/ewosapi/v2/planandprognosis/default-profile/site/${globalSiteId}`, request);
};
